import React from 'react';
import { annotationColors } from 'constants';
import { UserContentFlashcard } from 'types';

const LabelForUserContentItems = ({
  userContentItem,
  additionalUserText = null,
}) => {
  let userContent;
  const pageLabel = userContentItem?.page?.label;
  const userContentType = userContentItem.constructor.typeName?.slice(0, -1);
  const userContentColor = annotationColors[userContentItem?.color];
  const colorLabel = userContentColor
    ? `, ${userContentColor} ${userContentType}`
    : '';

  // if user content has no associated page label, it does not get an aria label
  if (!pageLabel) {
    return null;
  }

  if (userContentItem instanceof UserContentFlashcard) {
    userContent = additionalUserText;
  } else {
    userContent = userContentItem.truncatedSnippet;
  }

  return userContent ? (
    <>
      <span className="noTranslate">
        {userContent.replace(/\s+/g, ' ').trim()}
      </span>
      {colorLabel} on page <span className="noTranslate">{pageLabel}</span>
    </>
  ) : userContentItem.bookLocation.readableLocation ? (
    <span className="noTranslate">
      {userContentItem.bookLocation.readableLocation}
    </span>
  ) : null;
};

export default LabelForUserContentItems;
